const About = () => {
  return (
    <section
      id="about"
      className="relative bg-[url(./assets/images/banner.jpg)] xxs:py-16 xs:py-16 py-20 xxs:px-6 xs:px-6 px-12 bg-cover bg-center bg-no-repeat text-white"
    >
      {/* Left-side gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-brandBlue/100 via-brandBlue/90 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10  font-outfit mx-auto text-left">
        <h2 className="text-[1.3125rem] xxs:text-[1rem] xs:text-[1.2rem] tracking-[0.16em] uppercase text-[#808080]  mb-3">
          About the Conference
        </h2>
        <p className="text-[34px] font-bold text-left text-white xxs:text-3xl leading-[40px] mb-8">
          Adapting to a New Reality: The Role of Governments <br></br> in
          Shaping Economic Resilience, <br /> Governance, and Innovation
        </p>
        <p className="lg:max-w-[500px] md:max-w-[400px] xs:text-sm xxs:text-sm">
          In a rapidly evolving global landscape, governments must adapt to new
          realities by embracing innovative solutions and rethinking traditional
          approaches to governance, economic resilience, and public service
          delivery. This annual conference, International Governance Conference,
          brings together policymakers, experts, and thought leaders to explore
          how to foster economic resilience, innovation, and effective
          governance.
        </p>
      </div>
    </section>
  );
};

export default About;
